import { Component, OnInit, inject } from '@angular/core';
import { ClosetDoorsStandardService } from 'src/app/services/configurators-2d/applications/closet-doors-standard.service';
import { CurrentService } from 'src/app/services/current.service';

/**
 * Étape « configuration des vantaux » : orchestre la saisie des dimensions de
 * l'encoche puis, une fois celles-ci valides, la configuration de la plinthe et
 * le choix du nombre de vantaux.
 */
@Component({
  selector: 'ng-closet-doors-standard-door-configuration',
  templateUrl: './door-configuration.component.html',
  styleUrls: ['./door-configuration.component.scss'],
})
export class ClosetDoorsStandardDoorConfigurationComponent implements OnInit {
  private readonly closetDoorsService = inject(ClosetDoorsStandardService);
  private readonly current = inject(CurrentService);

  /**
   * Vrai quand hauteur et largeur sont toutes deux dans leurs plages valides.
   * Conditionne l'affichage de la carte "Configuration des vantaux".
   */
  get areDimensionsValid(): boolean {
    const { doorHeight, doorWidth } = this.current.closetDoors;
    const minW = this.closetDoorsService.globalMinWidth;
    const maxW = this.closetDoorsService.globalMaxWidth;
    return (
      doorHeight >= 1200 && doorHeight <= 2600 &&
      doorWidth > 0 &&
      (minW === 0 || doorWidth >= minW) &&
      (maxW === 0 || doorWidth <= maxW)
    );
  }

  ngOnInit(): void {
    // Charge les bornes globales (subtitle de la largeur) depuis tous les panels sans filtre.
    this.closetDoorsService.loadGlobalBounds();

    // Navigation retour : recharge les panels filtrés sans effacer la sélection courante.
    const { doorHeight, doorWidth } = this.current.closetDoors;
    if (doorHeight > 0 && doorWidth > 0 && this.closetDoorsService.panelGroups.length === 0) {
      this.closetDoorsService.getPanels(doorHeight, doorWidth).then(groups => {
        this.closetDoorsService.panelGroups = groups;
      });
    }
  }
}
